@if (chartOptions()) {
    <canvas baseChart class="chart" [options]="chartOptions()" type="line" [data]="chartData()"></canvas>
}
